export class IntervenantCategorie {
    static jsonMap = {
        id: { key: 'id', optional: true },
        idOrganisme: { key: 'idOrganisme', optional: true },
        idIntervenant: { key: 'idIntervenant', optional: true },
        caveCooperative: { key: 'caveCooperative', optional: true },
        caveParticuliere: { key: 'caveParticuliere', optional: true },
        negociant: { key: 'negociant', optional: true },
        bailleur: { key: 'bailleur', optional: true },
        apporteur: { key: 'apporteur', optional: true }
    };

    id: number;
    idOrganisme: number;
    idIntervenant: number;
    caveCooperative: boolean;
    caveParticuliere: boolean;
    negociant: boolean;
    bailleur: boolean;
    apporteur: boolean;
}
